/* import __COLOCATED_TEMPLATE__ from './help-article.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();